export default __webpack_public_path__ + "static/media/NewWindowiconGray.c01dd8fc.svg";